import type { DutySchedule } from "@dutyon/apis";
import type { DutyData } from "@dutyon/ui-kit";

/**
 * DutyData → DutySchedule 변환
 * @param data 현재 근무표 데이터
 * @param onlyFixed true면 isFixed인 셀만 포함
 */
export function toFixedSchedule(data: DutyData, onlyFixed = false): DutySchedule {
  const result: DutySchedule = {};
  for (const [nurseId, nurseSchedule] of Object.entries(data)) {
    for (const [dateStr, entry] of Object.entries(nurseSchedule)) {
      if (onlyFixed && !entry.isFixed) continue;
      if (!result[dateStr]) result[dateStr] = {};
      const wsId = entry.workShiftId;
      if (!result[dateStr][wsId]) result[dateStr][wsId] = [];
      result[dateStr][wsId].push(nurseId);
    }
  }
  return result;
}

/**
 * DutySchedule 결과를 기존 DutyData에 병합
 * 사용자가 고정해둔 셀(isFixed)은 보존됩니다.
 */
export function mergeIntoDutyData(base: DutyData, chunkSchedule: DutySchedule): DutyData {
  const next: DutyData = { ...base };
  for (const [dateStr, shiftMap] of Object.entries(chunkSchedule)) {
    for (const [workShiftId, nurseIds] of Object.entries(shiftMap)) {
      for (const nurseId of nurseIds) {
        if (!next[nurseId]) next[nurseId] = {};
        const wasFixed = base[nurseId]?.[dateStr]?.isFixed ?? false;
        next[nurseId][dateStr] = { workShiftId, isFixed: wasFixed };
      }
    }
  }
  return next;
}
